import React, { useState, useEffect } from "react";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import { Link, useParams } from "react-router-dom";
import API_URL from "../../api/API";
import ladyRun from "../../images/ladyRun.png";

export const CoachStaticSpeedTemplateDetail = () => {
  const { coach } = useCoachAuthContext();
  const {dispatch} = useCoachAuthContext();

  const { id } = useParams();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false); // For saving state
  const [successMessage, setSuccessMessage] = useState(""); // For success message
  const [isPurchased, setIsPurchased] = useState(false); // Check if template is purchased


  const fetchTemplateDetail = async () => {
    try {
      // Fetch template details
      const response = await fetch(`${API_URL.GET_COACH_STATIC_WORKOUT_TEMPLATE_FRONT_BY_ID}${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${coach.token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
  
      const data = await response.json();
      //console.log(data);
      setTemplate(data);
  
      // Fetch purchase data for the coach
      const purchaseResponse = await fetch(`${API_URL.GET_COACH_PURCHASE_DATA}${coach.id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${coach.token}`,
        },
      });
  
      if (!purchaseResponse.ok) {
        // If the purchase data API fails, just proceed without purchase checks
        console.warn(`Warning: Purchase data not found. Proceeding without purchase validation.`);
        return;
      }
  
      const purchaseData = await purchaseResponse.json();
  
      if (purchaseData && purchaseData.speed) {
        const purchasedTemplate = purchaseData.speed.find(
          (item) => item.template_id === id && item.payment_status === "COMPLETED"
        );
      
        if (purchasedTemplate) {
          setIsPurchased(true);
        }
      }
    } catch (err) {
      setError(err.message);
      console.error("Error fetching template details or purchase records:", err);
    } finally {
      setLoading(false);
    }
  };
  
  

  useEffect(() => {
    fetchTemplateDetail();
  }, [id]);

  // Handle Access Now button click to save the purchase data
  const handlePurchase = async () => {
    setSaving(true);

    try {
      const response = await fetch(API_URL.POST_COACH_PURCHASE_SPEED_DATA + coach.id, { // Replace with the correct API endpoint
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${coach.token}`,
        },
        body: JSON.stringify({
          template_id: template._id,
          warmup_routine_id: template.warmup_routine_id,
          price: template?.price,
          payment_transaction_id: "temp-transaction-id", // For now, using a dummy value
          payment_logs: "Dummy payment log", // For now, using a dummy value
          payment_status: 'COMPLETED',
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Purchase saved successfully:", data);
        // Set success message after successful purchase
      setSuccessMessage("Your purchase was successful! You now have access to the speed template.");
      setIsPurchased(true);
      // Dispatch action to update the account type
      dispatch({ type: "UPDATE_ACCOUNT_TYPE", payload: "STATIC PLAN" });

      // Update localStorage as well
      const updatedCoach = { ...coach, account_type: "STATIC PLAN" };
      localStorage.setItem("coach", JSON.stringify(updatedCoach));

      // Handle success (e.g., redirect to another page, show success message)
    } catch (err) {
      setError(err.message);
      console.error("Error saving purchase:", err);
    } finally {
      setSaving(false);
    }
  };


  return (
    <CoachLayout>
      <div className="bg-[#F6F6F6] h-full">
        {/* Show Loading or Error State */}
        {loading ? (
          <div className="text-center">
            <p>Loading template details...</p>
          </div>
        ) : error ? (
          <div className="text-center">
            <p className="text-red-500">Error: {error}</p>
          </div>
        ) : (
          // Main Content
          <div className="p-5 w-full max-w-2xl mx-auto h-full">
            <div className="bg-white h-[353px] w-full max-w-[353px] p-[18px_43px_55px] rounded-[15px] mx-auto relative">
              <div className="h-[260px] w-full max-w-[260px] flex justify-center items-center">
                <img
                  src={template?.photo ? `${API_URL.SERVER_PICTURE_URL}${template.photo}` : ladyRun}
                  alt={template?.title || "productDetail"}
                  className="object-cover w-full h-full rounded-[15px]"
                />
                <Link to="/coach/purchase/static-speed-templates" className="absolute top-5 left-5">
                  <ArrowL />
                </Link>
              </div>
            </div>
            <div className="mt-4">
              <div className="mb-4">
                <p className="text-black text-xl font-normal">{template?.title}</p>
                <p className="text-black text-xl font-normal">${template?.price}</p>
              </div>
              <p className="text-black text-base font-normal">
                {template?.description || "No description available."}
              </p>
            </div>
            {successMessage && (
              <div className="bg-green-500 text-white p-4 rounded-md mt-4 text-center">
                <p>{successMessage}</p>
              </div>
            )}

              <div className="w-full max-w-lg mt-[71px]">
                {isPurchased ? (
                  <Link
                    to={`/coach/static-warmup-routine/phase/${template.warmup_routine_id}/${template._id}`}
                    className="p-6 border border-black text-base font-semibold hover:opacity-70 rounded-[70px] w-full text-center block"
                  >
                    Access Now
                  </Link>
                ) : (
                  <button
                    onClick={handlePurchase}
                    className="p-6 border border-black text-base font-semibold hover:opacity-70 rounded-[70px] w-full"
                  >
                    Buy Now
                  </button>
                )}
              </div>
          </div>
        )}
      </div>
    </CoachLayout>
  );
};

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
